import { get, post, put, Success } from './methods';

export interface Pergunta {
  dataPergunta: string;
  dataResposta: string;
  flgPublica: boolean;
  idPergunta: number;
  lido: boolean;
  pergunta: string;
  resposta: string | null;
  usuarioResposta: string;
}

export interface PerguntaResponse {
  idPessoa: number;
  cpfUsuario: string;
  nome: string;
  perguntas: Array<Pergunta>;
}

export type ListaPerguntaResponse = Array<PerguntaResponse>

interface Resposta {
  idPergunta: number;
  resposta: string;
}

interface AlteraStatus {
  flgPublica: boolean;
  idPergunta: number;
}

export default {
  listar: (idAssembleia: number) => {
    const endpoint = 'pergunta/pergunta-assembleia';
    return get<ListaPerguntaResponse>(endpoint, {
      params: { idAssembleia },
    });
  },
  responder: (data: Resposta) => {
    const endpoint = 'pergunta/registra-resposta';
    return post<Success>(endpoint, data);
  },
  alterarStatus: (data: AlteraStatus) => {
    const endpoint = 'pergunta/publica';
    return put<Success>(endpoint, data);
  },
};
